import { Link } from "react-router-dom";
import { stories } from "@/mocks/stories";

export default function BreakingTicker() {
  const items = [...stories.slice(0, 6), ...stories.slice(0, 6)];

  return (
    <div className="flex items-stretch border-b border-background-300 bg-background-100">
      <div className="flex shrink-0 items-center gap-2 bg-primary-600 px-3 py-2.5 md:px-5">
        <span className="flex h-4 w-4 items-center justify-center">
          <i className="ri-radar-line text-sm text-background-50" />
        </span>
        <span className="whitespace-nowrap font-label text-xs font-medium tracking-wider text-background-50 md:text-sm">
          实时速报
        </span>
      </div>
      <div className="relative flex-1 overflow-hidden">
        <div className="flex w-max animate-ticker items-center">
          {items.map((story, index) => (
            <Link
              key={`${story.id}-${index}`}
              to={`/news/${story.id}`}
              className="flex shrink-0 items-center gap-2 py-2.5 pl-6 pr-6 font-label text-xs text-foreground-700 transition-colors hover:text-primary-600 md:text-sm"
            >
              <span className="block h-1 w-1 rounded-full bg-accent-500" />
              <span className="whitespace-nowrap">{story.title}</span>
              <span className="whitespace-nowrap text-foreground-400">{story.date}</span>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}